import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, type IonNav } from '@ionic/angular/standalone';

import { getParentURL } from '../helper/general.helper';

@Injectable({
  providedIn: 'root',
})
export class IonNavService {
  private navRef: IonNav | undefined;

  // services
  private readonly navController = inject(NavController);
  private readonly router = inject(Router);

  setNav(nav: IonNav) {
    this.navRef = nav;
  }

  async pushPage(component: any, properties?: any): Promise<void> {
    await this.navRef?.push(component, properties);
  }

  unsetNav(): void {
    this.navRef = undefined;
  }

  async goBack(): Promise<void> {
    await this.navRef?.pop();
  }

  canGoBack(): boolean {
    return !!this.navRef;
  }

  async popToRoot(): Promise<void> {
    if (this.navRef) {
      await this.navRef.popToRoot();
    }
  }

  public navigateBack(): Promise<boolean> {
    return this.navController.navigateBack(getParentURL(this.router.url));
  }
}
